import { PathParam, generatePath } from 'react-router-dom';

export function fillRoutePathWithParams<T extends string>(path: T, params: { [key in PathParam<T>]?: string }) {
  return generatePath(path, params as { [key in PathParam<T>]: string | null });
}
